export default __webpack_public_path__ + "static/media/05.2fb3bc09.png";